// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1JobSchema } from './v1/jobSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const partialImportAppPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  app_user_id: z.number().int().describe("AppUser id"),
});

export const partialImportAppHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Import job created
 */
export const partialImportApp200Schema = z.lazy(() => v1JobSchema);

/**
 * @description AppUser not found
 */
export const partialImportApp404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const partialImportAppMutationResponseSchema = z.lazy(() => partialImportApp200Schema);
